























import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import EmployeeSelector from "../../../../shared/components/EmployeeSelector/index.vue";
import {EmployeeType} from "@/enums/type";
import {FormModel} from "ant-design-vue";
import {ShiftStore} from "@/modules/shift/store";
import {checkEmployeeInShift} from "@/modules/shift/services";

const form = {
    employeeRowGuid: undefined,
    shiftId: undefined
}
@Component({
    name: "ShiftEmployeeForm",
    components: {EmployeeSelector}
})
export default class extends mixins(CommonMixin) {
    @Prop({ required: true, type: Number }) readonly shiftId!: number;
    @PropSync('visibleForm', { required: true, type: Boolean }) syncVisibleForm!: boolean;
    form = { ...form }
    rules = {
        employeeRowGuid: [{ required: true, message: "Chọn nhân viên", trigger: "change" }]
    }
    EmployeeType = EmployeeType;
    created() {
        this.form = { ...this.form, shiftId: this.shiftId as any };
    }
    onSubmit() {
        (this.$refs.shiftEmployeeForm as FormModel).validate(async (valid) => {
            if (!valid) return;
            try {
                await this.checkEmployeeInShift(this.form.employeeRowGuid);
            } catch (e) {
                this.$message.error(e?.response?.data?.message || "Thêm nhân viên thất bại");
            }
        })
    }

    resetForm() {
        this.form = { ...this.form, employeeRowGuid: undefined };
    }

    async checkEmployeeInShift(employeeRowGuid: any) {
        try {
            const { data } = await checkEmployeeInShift(employeeRowGuid);
            const result = data.data;
            console.log(result);
            if (result !== null) {
                const saveForm = this.saveForm;
                this.$confirm({
                    title: `Nhân viên đã có trong ca ${ result?.shift?.start } - ${ result?.shift?.end }, bạn vẫn muốn tiếp tục?`,
                    onOk() {
                        saveForm();
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                    okText: 'Tiếp tục',
                    okType: 'danger',
                    cancelText: 'Không',
                });
            } else {
                await this.saveForm();
            }
        } catch (e) {
        }
    }
    async saveForm() {
        await ShiftStore.addEmployeeToShift(this.form);
        this.$message.success("Thêm nhân viên thành công");
        this.resetForm();
        this.syncVisibleForm = false;
    }
}
